var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHerbs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-tone/Alt Meds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6188 23.9282C21.6188 23.9282 14.3791 24.767 15.4547 16.0386C20.5829 15.3689 22.726 19.0358 21.6188 23.9282Z",
    fill: "#F6816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5076 16.1008L21.6186 23.9281C21.6186 23.9281 18.1015 24.2644 16.4543 21.7934C15.0604 19.7043 15.1253 17.5964 15.4427 16.3332L15.5076 16.1008Z",
    fill: "#EEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6657 23.6263C21.6657 23.6263 14.426 24.4651 15.5016 15.7367C20.6298 15.0661 22.7729 18.7339 21.6657 23.6263Z",
    stroke: "#08162D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7577 12.9039C19.7577 12.9039 13.4845 13.631 14.4168 6.06879C18.8598 5.48716 20.717 8.66535 19.7577 12.9039Z",
    fill: "#6CD8AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3336 6.07153L19.6313 12.8829C19.6313 12.8829 16.7101 13.1955 15.282 11.055C14.0748 9.24478 14.1307 7.41779 14.4057 6.32377L14.3336 6.07153Z",
    fill: "#EEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9307 13.0542C19.9307 13.0542 13.6584 13.7803 14.5906 6.21907C19.0336 5.63744 20.89 8.81465 19.9307 13.0542Z",
    stroke: "#08162D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8589 14.6383C36.8589 14.6383 38.0995 16.1646 37.9868 16.3713C37.8741 16.5781 33.8882 25.5736 33.8882 25.5736L30.2773 25.4084L36.8589 14.6383Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2344 45.0931H32.6597V40.894H18.2344V45.0931Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2344 45.0931H32.6597V40.894H18.2344V45.0931Z",
    stroke: "#08162D",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M12.1816 45.5054H38.3745",
    stroke: "#08162D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.244 29.6614V35.1433C37.244 38.5293 34.8989 41.2742 32.0066 41.2742H19.04C16.1478 41.2742 13.8027 38.5293 13.8027 35.1433V29.6614",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M37.244 29.6614V35.1433C37.244 38.5293 34.8989 41.2742 32.0066 41.2742H19.04C16.1478 41.2742 13.8027 38.5293 13.8027 35.1433V29.6614",
    stroke: "#08162D",
    strokeWidth: 1.448,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0325 35.0612V32.5952C22.0325 32.1154 21.6773 31.7267 21.2409 31.7267H16.7096C16.2723 31.7267 15.918 32.1154 15.918 32.5952V35.0087C15.918 37.3837 17.6364 39.3156 19.7497 39.3156H22.3228C22.9828 39.3156 23.357 38.4797 22.9431 37.9149C22.3742 37.1384 22.0325 36.1463 22.0325 35.0612Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7405 27.4251L27.3672 26.068L27.8495 25.2925C27.8955 25.2183 32.4557 17.8796 33.965 15.3127C34.9117 13.7024 36.3326 13.556 37.3234 14.1257C38.445 14.7717 38.9417 16.1783 38.4792 17.3969C37.7111 19.4188 34.0912 26.7178 33.9379 27.0275L33.7405 27.4251Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9044 29.8642H13.1423C12.5112 29.8642 12 29.3023 12 28.6099V26.771C12 26.0786 12.5112 25.5168 13.1423 25.5168H37.9044C38.5355 25.5168 39.0476 26.0786 39.0476 26.771V28.6099C39.0476 29.3023 38.5355 29.8642 37.9044 29.8642Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9044 29.8642H13.1423C12.5112 29.8642 12 29.3023 12 28.6099V26.771C12 26.0786 12.5112 25.5168 13.1423 25.5168H37.9044C38.5355 25.5168 39.0476 26.0786 39.0476 26.771V28.6099C39.0476 29.3023 38.5355 29.8642 37.9044 29.8642Z",
    stroke: "#08162D",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M14.3711 27.6502H18.962",
    stroke: "#E9E9E9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M20.3262 27.6502H21.7155",
    stroke: "#E9E9E9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5626 13.2497C29.5626 13.2497 29.861 23.4767 19.7975 21.1512C19.4973 13.8996 23.9691 11.2387 29.5626 13.2497Z",
    fill: "#6CD8AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7985 21.151L29.5636 13.2495C29.5636 13.2495 29.4753 18.409 26.8715 20.1608C24.2686 21.9126 21.4196 21.7237 19.7246 21.2113",
    fill: "#EEFDF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7286 13.3995C29.7286 13.3995 30.027 23.6265 19.9635 21.301C19.6633 14.0494 24.1351 11.3885 29.7286 13.3995Z",
    stroke: "#08162D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerbs);
export default __webpack_public_path__ + "static/media/herbs.25689ecb17bfa91755ff9a12d57baee0.svg";
export { ForwardRef as ReactComponent };